// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kzsl4","footerContent":"Footer_footerContent__YmIii","footerSection":"Footer_footerSection__An1GO","footerBottom":"Footer_footerBottom__44UB0"};